import {
  BUNDLE_BEAN,
  PACKAGE_BEAN,
  PRODUCT_BEAN
} from '@app/constants/commonConstants';
export const COMPATIBILITY_ID = 'pdp__compatibility';
export const DESCRIPTION_ID = 'pdp__description';
export const DIAGRAMS_ID = 'pdp__diagrams';
export const SPECIFICIFICATIONS_ID = 'pdp__specifications';
export const RELATED_PARTS_ID = 'pdp__related_parts';
export const REQUIRED_INSTALLATION_PARTS_ID =
  'pdp__required_installation_parts';
export const COMPARISON_TABLE_ID = 'pdp__comparison_table';
export const PDP_ESPOT_1_NAME = 'PCC_PDP_Layout_V2_eSpot-1';
//Name PCC_PDP_Layout_V2_eSpot-3 is not a mistake , CMC gave #3 name to  espot #2 based on story number 172653
export const PDP_ESPOT_2_NAME = 'PCC_PDP_Layout_V2_eSpot-3';
export const PDP_ESPOT_3_NAME = 'PCC_PDP_Layout_V2_eSpot-2';
export const PDP_ESPOT_4_NAME = 'PCC_PDP_Layout_V2_eSpot-4';
export const PDP_ESPOT_5_NAME = 'PCC_PDP_Layout_V2_eSpot-5';
export const PDP_ESPOT_6_NAME = 'PCC_PDP_Layout_V2_eSpot-6';
export const PDP_ESPOT_7_NAME = 'PCC_PDP_Layout_V2_eSpot-7';

export const CAT_PDP_KIT_EMARKETINGSPOT_TOP = 'CAT_PDP_KIT_EMARKETINGSPOT_TOP';
export const CAT_PDP_KIT_EMARKETINGSPOT_BOTTOM =
  'CAT_PDP_KIT_EMARKETINGSPOT_BOTTOM';
export const CAT_PDP_BUNDLES_EMARKETINGSPOT_BOTTOM =
  'CAT_PDP_BUNDLES_EMARKETINGSPOT_BOTTOM';
export const LUCID_BREADCRUMB_KEY = 'breadCrumbs';
export const SOLR_BREADCRUMB_KEY = 'breadCrumb';
export const ESPOTS = {
  [PACKAGE_BEAN]: {
    espotNames: [
      CAT_PDP_KIT_EMARKETINGSPOT_TOP,
      CAT_PDP_KIT_EMARKETINGSPOT_BOTTOM
    ].join(','),
    espot1: CAT_PDP_KIT_EMARKETINGSPOT_TOP,
    espot7: CAT_PDP_KIT_EMARKETINGSPOT_BOTTOM
  },
  [BUNDLE_BEAN]: {
    espotNames: [CAT_PDP_BUNDLES_EMARKETINGSPOT_BOTTOM],
    espot7: CAT_PDP_BUNDLES_EMARKETINGSPOT_BOTTOM
  },
  [PRODUCT_BEAN]: {
    espotNames: [
      PDP_ESPOT_1_NAME,
      PDP_ESPOT_2_NAME,
      PDP_ESPOT_3_NAME,
      PDP_ESPOT_4_NAME,
      PDP_ESPOT_5_NAME,
      PDP_ESPOT_6_NAME,
      PDP_ESPOT_7_NAME
    ].join(','),
    espot1: PDP_ESPOT_1_NAME,
    espot2: PDP_ESPOT_2_NAME,
    espot3: PDP_ESPOT_3_NAME,
    espot4: PDP_ESPOT_4_NAME,
    espot5: PDP_ESPOT_5_NAME,
    espot6: PDP_ESPOT_6_NAME,
    espot7: PDP_ESPOT_7_NAME
  }
};

export const PAGE_SIZE = 32;
export const INITIAL_PAGINATION = 1;
